<template>
    <!--        ***********************************************************************************************************-->
    <!--            SECTION SUCCESS QUAND TOUT C'EST BIEN PASSE INCHALLAH -->
    <!--        ***********************************************************************************************************-->

    <section class="congrats">
        <loading-block v-if="dataIsLoading">
        </loading-block>
        <rich-pretty-info v-else>
            <template slot="image">
                <img src="../../assets/img/illustrations/ajout-danseur.svg" height="200" width="200"/>
            </template>
            <template slot="content">
                <h1>
                    Vous venez d'ajouter {{ user.firstname }} à votre famille !
                </h1>
            </template>
            <template slot="actions">
                <uni-cta-link v-if="!family.is_payment_confirmed && isSubscriptionOpen"
                              :to="{name: 'classes.new', params: {id: $route.params.id}}">
                    Inscrire à un cours
                </uni-cta-link>
                <uni-cta-link to="/" class="uni-cta-link--secondary">
                    Retour à l'accueil
                </uni-cta-link>
            </template>
        </rich-pretty-info>
    </section>
</template>

<script>
    import RichPrettyInfo from "../../components/c-blocks/RichPrettyInfo";
    import UniCtaLink from "../../components/a-elements/UniCtaLink";
    import LoadingBlock from "../../components/c-blocks/LoadingBlock";
    import {mapGetters} from "vuex";

    export default {
        name: "success",
        components: {LoadingBlock, UniCtaLink, RichPrettyInfo},
        data() {
            return {
                dataIsLoading: true,
                user: {},
                family: {}
            }
        },
        computed: {
          ...mapGetters({isSubscriptionOpen: 'isSubscriptionOpen'})
        },
        created() {
            this.user = this.$getModel('users', this.$route.params.id)
                .then(data => {
                    this.user = data
                    this.$getModel('families', data.family_id)
                        .then(req => {
                            this.family = req
                            this.dataIsLoading = false
                        })
                })
        }
    }
</script>

<style scoped lang="scss">

</style>
